import { CdkCell, CdkCellDef, CdkColumnDef, CdkHeaderCell, CdkHeaderCellDef } from '@angular/cdk/table';
import { Component, Input } from '@angular/core';
import { SearchStoreService } from '@ecs-services/search/search-store.service';
import { TranslatePipe } from '@ngx-translate/core';
import { BaseTableModule, SelectableRow } from '@os-components';
import { SewButton } from '@sew/ui-components-angular/standalone';
import { SparePartList } from '../../type-designation-result.component';

@Component({
    selector: 'ecs-spare-part-lists-table',
    templateUrl: './spare-part-lists-table.component.html',
    styleUrls: ['./spare-part-lists-table.component.scss'],
    imports: [
        SewButton,
        BaseTableModule,
        CdkColumnDef,
        CdkHeaderCellDef,
        CdkHeaderCell,
        CdkCellDef,
        CdkCell,
        TranslatePipe,
    ],
})
export class SparePartListsTableComponent {
    // async pipe will return null when no value is emitted by Observable yet
    // https://stackoverflow.com/questions/61681239/async-pipe-sends-null-value-to-the-child-component
    @Input() public set items(value: SelectableRow<SparePartList>[] | undefined | null) {
        if (value) {
            this._items = value;
        }
    }

    @Input() public columns: string[] | null = null;

    // eslint-disable-next-line @typescript-eslint/naming-convention
    public _items: SelectableRow<SparePartList>[] = [];

    public constructor(private searchStore: SearchStoreService) {}

    public onSearch(searchValue: string) {
        this.searchStore.search(searchValue);
    }
}
